
import { ModalVertical, Message, Keyboard } from 'tplus-components-touch'
import { FormControl as Input } from 'tinper-bee'
import React, { Component } from 'react';
import { Action } from 'mutants-appfx'
import { platform } from 'mutants-util';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';
import { getFixedNumber } from './utils'

/**
 * @props {boolean} visible
 * @props {fun} cancel 
 * @props {fun} ok
 * @props {string} title
 * @props {string} placeholder
 */
@observer
class PwdModal extends Component {
  constructor(props, context) {
    super(props, context)
    const { isHorizontalPad, isHorizontalSunMi } = platform || {};
    this.isHorizontalPad = !!isHorizontalPad;
  }

  static contextTypes = {
    onEvent: PropTypes.func,
    viewModel: PropTypes.object,
    stores: PropTypes.object,
    storeInfo: PropTypes.object,
    isReturn: PropTypes.bool,
    Idmember: PropTypes.number,
  }

  controllerEvent = (methodName, methodArgs) => {
    this.context.onEvent({ 'controllerEvent': Action.fromJS(this.context.viewModel, methodName) }, 'controllerEvent', methodArgs);
  }

  componentDidMount() {
    if (this.isHorizontalPad) return;
    if (this.pwdinput) {
      const input = this.pwdinput.input;
      setTimeout(() => { input.focus() }, 200)
    }
  }


  ok = () => {
    const { ok } = this.props;
    const input = this.pwdinput.input;
    if (ok) {
      ok(input.value).then((result) => {
        if (!result) return;
      })
    }
  }

  cancel = () => {
    this.props.cancel && this.props.cancel()
  }

  fKeyboardOnOk = () => {
    const input = this.pwdinput.input;
    return (e) => {
      input.blur();
      Keyboard.close();
      this.ok();
    }
  }
  fKeyboardOnClose = () => {
    const input = this.pwdinput.input;
    return (e) => {
      input.blur();
      Keyboard.close();
    }
  }

  render() {
    const { visible, title, placeholder, cardno, balance } = this.props;
    let footer = <span onClick={this.ok}></span>;
    return (
      <ModalVertical
        show={visible}
        animation={true}
        className='pwd-modal'
        // modalType={'small'}
        title={title}
        footer={footer}
        backdrop={true}
        closeButton={true}
        cancel={this.cancel}
      >
        <div className='pwd-container'>
          <div className="row">
            <span className="label">卡号：</span><span className="cardno">{cardno}</span>
          </div>
          <div className="row">
            <span className="label">余额：</span><span className="balance">{getFixedNumber(balance)}</span>
          </div>
          <div className="row">
            <span className="label">密码：</span>
            <span>
              <Input
                type="password"
                className="pwd"
                style={{ marginLeft: '-20px' }}
                placeholder="请输入储值卡密码"
                ref={input => this.pwdinput = input}
                onFocus={(e) => {
                  const inputTarget = this.pwdinput.input;
                  Keyboard.open((v) => {
                    const value = Keyboard.getNewValue(inputTarget, inputTarget.value, v);
                    inputTarget.value = value;
                  }, this.fKeyboardOnOk(), this.fKeyboardOnClose())()
                }
                }
                onBlur={(e) => { Keyboard.close(); }}
              />
            </span>
          </div>
          <div className="btn">
            <div className="fr">
              <button
                type="button"
                onClick={this.cancel}>取消
                  </button>
              <button
                type="button"
                onClick={this.ok}>确定
                  </button>
            </div>
          </div>
        </div>
      </ModalVertical>
    );

  }
}
export default PwdModal;